<template>

  <div class="gantt-container">

    <el-icon :size="16" color = "#606266" class="gantt-toolbar" @click="delSnapshot" >
      <ElIconClose/>
    </el-icon>

    <IframeGantt class="gantt-div" ref="gantt" ></IframeGantt>

  </div>

</template>

<script>
import IframeGantt from './IframeGantt.vue';
import {nanoid} from 'nanoid';

export default {
  name: 'ProjectTaskSnapshot',
  components: { IframeGantt },
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      gantt_div_id: nanoid(),
      dateRange:{
        start_date: new Date(),
        end_date: new Date()
      },
      taskList:[]
    }
  },
  methods: {
    async loadData() {
      this.taskList = await this.$http('prjTaskSnapshotService.getTasks', {id: this.parentData.id})
      let tasks = {"data": this.taskList, "links": []}

      this.$refs.gantt.refresh({}, tasks);
    },
    async delSnapshot() {
      this.$confirm('你确定要删除此快照吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.submitDel();
      });
    },
    async submitDel() {
      await this.$http('prjTaskSnapshotService.delSnapshot', {id: this.parentData.id});
      this.$message.success('删除成功, 请关闭本窗口')
    },
  },
  mounted: function () {
    this.loadData();
  }
}
</script>

<style scoped>

.gantt-container {
  position: relative; /* 确保工具栏的定位是相对于这个容器 */
}

/* 工具栏样式 */
.gantt-toolbar {
  position: absolute;
  top:25px;
  left: 20px;
  padding: 0px;
  z-index: 999; /* 确保工具栏在甘特图上方 */
}

.gantt-div {
  position: absolute;
  top:0px;
  left: 0px;
  width: 100%;
  height: 100%;
  overflow: auto;
}

</style>